import { cn } from "../../lib/utils"
import { motion } from "framer-motion"

interface GridPatternCardProps {
  children: React.ReactNode
  className?: string
  patternClassName?: string
  gradientClassName?: string
}

export function GridPatternCard({ 
  children, 
  className,
  patternClassName,
  gradientClassName
}: GridPatternCardProps) {
  return (
    <motion.div
      className={cn(
        "tw-border tw-w-full tw-rounded-md tw-overflow-hidden",
        "tw-bg-background",
        "tw-border-border",
        "tw-p-0",
        className
      )}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className={cn(
        "tw-size-full tw-bg-repeat tw-bg-[length:30px_30px]",
        "tw-bg-grid-pattern-light tw-dark:tw-bg-grid-pattern",
        patternClassName
      )}>
        <div className={cn(
          "tw-size-full tw-bg-gradient-to-tr",
          "tw-from-background/90 tw-via-background/40 tw-to-background/10",
          gradientClassName
        )}>
          {children}
        </div>
      </div>
    </motion.div>
  )
}

export function GridPatternCardBody({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div 
      className={cn("tw-text-left tw-p-0 tw-md:tw-p-6", className)} 
      {...props} 
    />
  )
}
